import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { Button } from 'react-bootstrap'
import { _unallocateDoor } from './actions'
import { useDispatch } from 'react-redux'

const customStyles = {
    content: {
        top: '30%',
        left: '30%',
        right: '30%',
        bottom: '30%',
        borderRadius: "20px",
        textAlign: "center",
        color: "rgb(83, 88, 95)",
        boxShadow: "2px 2px 30px grey"
    }
}

export default ({ allocation, door }) => {
    const dispatch = useDispatch()

    const [modalOpen, toggleModal] = useState(false)
    const [delivery, setDelivery] = useState(null)

    if (modalOpen && !delivery) {
        const url = `${window.MYQLOCX_API}/subject/${localStorage.userType}/deliveries/documents?id=${allocation.id}`
        axios.get(url).then(t => {
            setDelivery(t.data[0])
        })
    }

    return (
        <div>
            <div className="cluster-box-allocated">
                <div className="cluster-box-title">
                    <b>{door.display_name}</b>
                </div>
                <hr style={{ width: "95%" }} />
                <div className="cluster-box-status">
                    Bokad: <span style={{ fontWeight: "bold", color: "rgb(187, 16, 16)" }}>Leverans</span>
                </div>
                <br />
                <div className="cluster-box-button" onClick={() => toggleModal(!modalOpen)}>
                    Visa mer
                </div>
                <br />

                <div>
                    <Modal
                        isOpen={modalOpen}
                        onRequestClose={() => toggleModal()}
                        style={customStyles}>

                        <div style={{ padding: "20px" }}>
                            <div className="cluster-box-modal-close" onClick={() => toggleModal()}>X</div>
                            <h2 style={{ textAlign: "center" }}>{door.display_name}</h2>
                            <hr />

                            {!delivery ? null :
                                <div>
                                    PaketID: {delivery.packageid}
                                </div>
                            }

                            <Button className="cluster-box-unallocate" style={{ marginTop: "30%" }} onClick={() => dispatch(_unallocateDoor(door._id))}>Avboka paketlåda</Button>
                        </div>
                    </Modal>
                </div>
            </div>
        </div>
    )
}
